import { label } from "@/lib/format";

const TONES = {
  draft: "bg-slate-100 text-slate-700 border-slate-200",
  shared: "bg-sky-50 text-sky-700 border-sky-200",
  revised: "bg-slate-100 text-slate-500 border-slate-200",
  won: "bg-emerald-50 text-emerald-700 border-emerald-200",
  sent: "bg-emerald-50 text-emerald-700 border-emerald-200",
  failed: "bg-red-50 text-red-700 border-red-200",
  lost: "bg-red-50 text-red-700 border-red-200",
  converted: "bg-emerald-100 text-emerald-800 border-emerald-300",
  new: "bg-slate-100 text-slate-700 border-slate-200",
  contacted: "bg-sky-50 text-sky-700 border-sky-200",
  qualified: "bg-violet-50 text-violet-700 border-violet-200",
  pending_approval: "bg-amber-50 text-amber-700 border-amber-200",
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  approved: "bg-blue-50 text-blue-700 border-blue-200",
  in_production: "bg-violet-50 text-violet-700 border-violet-200",
  partially_dispatched: "bg-indigo-50 text-indigo-700 border-indigo-200",
  dispatched: "bg-indigo-100 text-indigo-800 border-indigo-200",
  closed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  cancelled: "bg-red-50 text-red-700 border-red-200",
  rejected: "bg-red-50 text-red-700 border-red-200",
  withdrawn: "bg-slate-100 text-slate-500 border-slate-200",
  in_transit: "bg-amber-50 text-amber-700 border-amber-200",
  delivered: "bg-emerald-50 text-emerald-700 border-emerald-200",
  received: "bg-emerald-50 text-emerald-700 border-emerald-200",
  in_warranty: "bg-emerald-50 text-emerald-700 border-emerald-200",
  under_amc: "bg-teal-50 text-teal-700 border-teal-200",
  expiring_soon: "bg-amber-50 text-amber-700 border-amber-200",
  expired: "bg-red-50 text-red-700 border-red-200",
  not_started: "bg-slate-100 text-slate-600 border-slate-200",
  unknown: "bg-slate-100 text-slate-500 border-slate-200",
  operational: "bg-emerald-50 text-emerald-700 border-emerald-200",
  under_repair: "bg-amber-50 text-amber-700 border-amber-200",
  down: "bg-red-50 text-red-700 border-red-200",
  decommissioned: "bg-slate-100 text-slate-500 border-slate-200",
  handed_over: "bg-blue-50 text-blue-700 border-blue-200",
  installed: "bg-violet-50 text-violet-700 border-violet-200",
  commissioned: "bg-indigo-50 text-indigo-700 border-indigo-200",
  on_hold: "bg-amber-50 text-amber-700 border-amber-200",
  no_service: "bg-slate-100 text-slate-500 border-slate-200",
  project: "bg-sky-50 text-sky-700 border-sky-200",
  invoice: "bg-violet-50 text-violet-700 border-violet-200",
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  inactive: "bg-red-50 text-red-700 border-red-200",
  outward: "bg-sky-50 text-sky-700 border-sky-200",
  inward: "bg-teal-50 text-teal-700 border-teal-200",
  projection: "bg-violet-50 text-violet-700 border-violet-200",
  auto_approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  partially_delivered: "bg-amber-50 text-amber-700 border-amber-200",
  returned: "bg-red-50 text-red-700 border-red-200",
  pod_pending: "bg-amber-50 text-amber-700 border-amber-200",
  pod_received: "bg-emerald-50 text-emerald-700 border-emerald-200",
  pod_not_required: "bg-slate-100 text-slate-500 border-slate-200",
  invoice_pending: "bg-amber-50 text-amber-700 border-amber-200",
  invoice_received: "bg-emerald-50 text-emerald-700 border-emerald-200",
  invoice_not_needed: "bg-slate-100 text-slate-500 border-slate-200",
  ready_for_qc: "bg-sky-50 text-sky-700 border-sky-200",
  not_submitted: "bg-slate-100 text-slate-500 border-slate-200",
  within_budget: "bg-emerald-50 text-emerald-700 border-emerald-200",
  over_budget: "bg-red-50 text-red-700 border-red-200",
  no_budget: "bg-slate-100 text-slate-500 border-slate-200",
  not_estimated: "bg-slate-100 text-slate-500 border-slate-200",
  planned: "bg-sky-50 text-sky-700 border-sky-200",
  fully_assigned: "bg-emerald-50 text-emerald-700 border-emerald-200",
  partially_assigned: "bg-amber-50 text-amber-700 border-amber-200",
  started: "bg-violet-50 text-violet-700 border-violet-200",
  due: "bg-amber-50 text-amber-700 border-amber-200",
  billed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  not_started: "bg-slate-100 text-slate-600 border-slate-200",
  fully_planned: "bg-emerald-50 text-emerald-700 border-emerald-200",
  partially_planned: "bg-amber-50 text-amber-700 border-amber-200",
  submitted: "bg-sky-50 text-sky-700 border-sky-200",
  done: "bg-emerald-50 text-emerald-700 border-emerald-200",
  invoiced: "bg-emerald-50 text-emerald-700 border-emerald-200",
  partially_invoiced: "bg-amber-50 text-amber-700 border-amber-200",
  fully_moved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  partially_moved: "bg-amber-50 text-amber-700 border-amber-200",
};

export const StatusBadge = ({ status, testid, text }) => (
  <span data-testid={testid} className={`inline-flex items-center px-2 py-0.5 rounded border text-[11px] font-semibold uppercase tracking-wider whitespace-nowrap ${TONES[status] || TONES.draft}`}>
    {text || label(status).replace(/^pod /, "POD ").replace(/^invoice not needed$/, "no invoice yet").replace(/^in production$/, "in execution")}
  </span>
);

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-6">
    <div>
      <h1 className="text-2xl font-bold tracking-tight text-slate-900" data-testid="page-title">{title}</h1>
      {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

export const Panel = ({ title, actions, children, className = "", testid }) => (
  <section className={`bg-white border border-slate-200 rounded-md ${className}`} data-testid={testid}>
    {title && (
      <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200">
        <h3 className="text-sm font-semibold text-slate-800">{title}</h3>
        <div className="flex gap-2">{actions}</div>
      </div>
    )}
    <div className="p-4">{children}</div>
  </section>
);

export const Field = ({ k, v, mono }) => (
  <div>
    <div className="text-[11px] uppercase tracking-wider text-slate-500">{k}</div>
    <div className={`text-sm text-slate-900 mt-0.5 break-words ${mono ? "font-mono" : ""}`}>{v || "—"}</div>
  </div>
);

export const Empty = ({ children, testid }) => (
  <div className="text-sm text-slate-500 py-8 text-center" data-testid={testid}>{children}</div>
);
